import './PageTitle.scss';

import React from 'react';
import PropTypes from 'prop-types';

class PageTitle extends React.Component {
  constructor(props) {
    super(props);
    this.visible = this.props.visible || true;
  }

  render() {
    if (!this.visible) {
      return;
    }

    return (
      <div className="PageTitle">
        {this.title()}
        {this.subtitle()}
      </div>
    );
  }

  subtitle() {
    if (this.props.subtitle) {
      return <h2 className={`PageTitle-subtitle subtitle`}>{this.props.subtitle}</h2>;
    }
  }

  title() {
    let size;
    switch (this.props.size) {
      case 'small':
        size = 4;
        break;
      default:
        size = 2;
        break;
    }

    return <h1 className={`PageTitle-title title is-${size}`}>{this.props.title}</h1>;
  }
}

PageTitle.propTypes = {
  size: PropTypes.oneOf(['small']),
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  visible: PropTypes.bool,
};

export default PageTitle;
